import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule, NO_ERRORS_SCHEMA, Type } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "@directives/_resourceFilters/_resourceFilters.directives.module";
import { VehicleDirectivesModule } from "@directives/_vehicle/_vehicle.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { GroupsModule } from "../resourceManagement/groups/groups.module";
import { DepotComplianceComponent } from "./depot-compliance/depot-compliance.component";
import { DriverBehaviourComparisonComponent } from "./driver-behaviour/driver-behaviour-comparison.component";
import { DriverBehaviourStackComponent } from "./driver-behaviour/driver-behaviour-stack/driver-behaviour-stack.component";
import { VehicleUtilisationComponent } from "./vehicleUtilisation/vehicle-utilisation.component";

const privateComponents: Type<any>[] = [
    VehicleUtilisationComponent,
    DepotComplianceComponent,
    DriverBehaviourComparisonComponent,
    DriverBehaviourStackComponent,
];

const publicComponents: any[] = [
];

const declarations: Type<any>[] = [
];

const providers: any[] = [
];

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        BrowserAnimationsModule,
        ScrollingModule,
        VeriDirectivesModule,
        LayoutDirectivesModule,
        PipesModule,
        ResourceFiltersDirectivesModule,
        MiscDirectivesModule,
        VehicleDirectivesModule,
        FormsDirectivesModule,
        CoreDirectivesModule,
        VTableModule,
        GroupsModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [NO_ERRORS_SCHEMA] //needed for highcharts
})
export class ExploreModule {
    constructor() {
    }
}
